// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .biz-flow header.pseudo-header {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
app-root .lf-flow header.pseudo-header {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
@media (min-width: 1151px) {
  app-root .lf-flow header.pseudo-header {
    width: 66%;
  }
}
app-root header.pseudo-header {
  padding: 12px 40px;
  position: fixed;
  max-height: 64px;
  top: 0;
  z-index: 20;
  box-sizing: border-box;
  background-color: white;
  border-bottom: 1px solid var(--header-border);
}
app-root header.pseudo-header a {
  display: inline-block;
}
app-root header.pseudo-header a .logo {
  display: inline-block;
  width: 200px;
  height: auto;
  color: var(--primary);
}
@media (max-width: 599px) {
  app-root header.pseudo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
  }
  app-root header.pseudo-header a {
    flex: none;
  }
  app-root header.pseudo-header a .logo {
    width: 120px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Components/PseudoHeader/PseudoHeader.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;AALA;ED+BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ACvBF;AAZA;ED+BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AChBF;ADoDE;EAAA;IACE,UAAA;ECjDF;AACF;AAxBA;EASI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;EAEA,uBAAA;EACA,6CAAA;AAiBJ;AAlCA;EAoBM,qBAAA;AAiBN;AArCA;EAsBQ,qBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AAkBR;AAbI;EAAA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;IACA,kBAAA;EAgBJ;EArBE;IAQI,UAAA;EAgBN;EAxBE;IAUM,YAAA;EAiBR;AACF","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../Styles/mediaQueries';\n@import '../../Styles/utilities';\n\napp-root {\n  .biz-flow header.pseudo-header {\n    .fixed-full-width-content();\n  }\n  .lf-flow header.pseudo-header {\n    .fixed-two-third-width-content();\n  }\n\n  header.pseudo-header {\n    padding: 12px 40px;\n    position: fixed;\n    max-height: @pseudo-header-height;\n    top: 0;\n    z-index: 20;\n    box-sizing: border-box;\n\n    background-color: white;\n    border-bottom: 1px solid var(--header-border);\n\n    a {\n      display: inline-block;\n      .logo {\n        display: inline-block;\n        width: 200px;\n        height: auto;\n        color: var(--primary);\n      }\n    }\n\n    // On phones the logo and the sign-in prompt share one row, so they can't overlap\n    @media @mobile {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      padding: 12px @body-gutter-width;\n\n      a {\n        flex: none;\n        .logo {\n          width: 120px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
